var _rect, _path, _path2, _rect2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcAwardCircle = function SvgIcAwardCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8075 13.49V14.23L22.2675 12.18C20.9275 11.41 19.0575 11.41 17.7275 12.18L14.1875 14.24V13.49C14.1875 11.24 15.4175 10 17.6675 10H22.3275C24.5775 10 25.8075 11.24 25.8075 13.49Z",
    fill: "#87C9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 15.9722L25.7 15.9022L24.34 15.1222L21.52 13.4922C20.66 12.9922 19.34 12.9922 18.48 13.4922L15.66 15.1122L14.3 15.9122L14.12 16.0022C12.37 17.1822 12.25 17.4022 12.25 19.2922V23.8122C12.25 25.7022 12.37 25.9222 14.16 27.1322L18.48 29.6222C18.91 29.8822 19.45 29.9922 20 29.9922C20.54 29.9922 21.09 29.8722 21.52 29.6222L25.88 27.1022C27.64 25.9222 27.75 25.7122 27.75 23.8122V19.2922C27.75 17.4022 27.63 17.1822 25.84 15.9722ZM22.79 21.5022L22.18 22.2522C22.08 22.3622 22.01 22.5722 22.02 22.7222L22.08 23.6822C22.12 24.2722 21.7 24.5722 21.15 24.3622L20.26 24.0022C20.12 23.9522 19.89 23.9522 19.75 24.0022L18.86 24.3522C18.31 24.5722 17.89 24.2622 17.93 23.6722L17.99 22.7122C18 22.5622 17.93 22.3522 17.83 22.2422L17.21 21.5022C16.83 21.0522 17 20.5522 17.57 20.4022L18.5 20.1622C18.65 20.1222 18.82 19.9822 18.9 19.8622L19.42 19.0622C19.74 18.5622 20.25 18.5622 20.58 19.0622L21.1 19.8622C21.18 19.9922 21.36 20.1222 21.5 20.1622L22.43 20.4022C23 20.5522 23.17 21.0522 22.79 21.5022Z",
    fill: "#87C9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EBECF0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAwardCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-award-circle.75b96570.svg";
export { ForwardRef as ReactComponent };